module.exports = __webpack_public_path__ + "4f5771d3a3e58b302d211e263c1fbc6c.eot";